<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <form
          @submit.prevent="
          action === 'add' ? addLabel() : updateLabel()">
          <div class="modal-container child">
            <div class="modal-header">
              <h3>
                {{
                  action === 'add'
                    ? 'Add Label'
                    : 'Edit Label'
                }}
              </h3>
            </div>
            <div class="modal-body">
              <div class="form-group row">
                <label for="label-name" class="col-sm-4">
                  Translation Label
                </label>
                <div class="col-sm-8">
                  <input
                    id="label-name"
                    v-model="labelInModal.name"
                    :class="{
                      'has-error':
                        hasErrors &&
                        labelInModal.name === null,
                    }"
                    placeholder="eg: NG_SHOPPING_CART"
                    name="label-name"
                    type="text"
                    class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group row">
                <label for="label-group" class="col-sm-4">
                  Group
                </label>
                <div class="col-sm-8">
                  <select
                    id="label-group"
                    v-model="labelInModal.group.id"
                    name="label-group"
                    class="form-control form-control-sm">
                    <option value 
                            selected 
                            disabled>
                      Select group
                    </option>
                    <option
                      v-for="(eachGroup,
                              groupIndex) in groupsInModal"
                      :key="groupIndex + 'option'"
                      :value="eachGroup.id">
                      {{ eachGroup.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="action === 'add'" class="form-group row">
                <div
                  :class="{ 'has-error': hasErrors }"
                  class="col-xs-12">
                  <label for="label_en_translation">
                    Translation
                  </label>
                  <textarea
                    id="label_en_translation"
                    v-model="labelInModal.defaultTranslation"
                    name="label_en_translation"
                    rows="5"
                    class="form-control"/>
                </div>
              </div>
              <div
                v-if="hasErrors"
                class="alert alert-danger"
                role="alert">
                <button type="button" class="close">
                  <span aria-hidden="true">×</span>
                </button>
                <p>Please fil in the mandatory fields.</p>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                {{ action === 'add' ? 'Add' : 'Edit' }}
              </button>
              <button
                type="button"
                class="modal-default-button btn btn-default"
                @click="$emit('close')">
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '../services/eventBus.js';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['action', 'groups', 'label',],
	data() {
		return {
			labelInModal: {},
			groupsInModal: this.groups,
			hasErrors: false,
		};
	},
	computed: {
		isValid() {
			return (
				this.labelInModal.name !== '' &&
				this.labelInModal.group.id !== ''
			);
		},
	},
	created() {
		if (this.action === 'add') {
			this.labelInModal = {
				id: null,
				name: '',
				group: {
					id: '',
				},
				defaultTranslation: '',
			};
		} else {
			this.labelInModal = {
				id: this.label.id,
				name: this.label.name,
				group: this.label.group,
			};
		}
	},
	methods: {
		addLabel() {
			let _self = this;
			// Let's validate
			if (
				this.labelInModal.name !== '' &&
				this.labelInModal.group.id !== '' &&
				this.labelInModal.defaultTranslation !== ''
			) {
				this.hasErrors = false;
				EventBus.$emit('saveLabel', _self.labelInModal);
				_self.labelInModal = {
					id: null,
					name: '',
					group: {
						id: '',
					},
					defaultTranslation: '',
				};
			} else {
				this.hasErrors = true;
			}
		},
		updateLabel() {
			let _self = this;
			// Let's validate
			if (
				this.labelInModal.name !== '' &&
				this.labelInModal.group.id !== ''
			) {
				this.hasErrors = false;
				EventBus.$emit('updateLabel', _self.labelInModal);
				_self.labelInModal = {
					id: null,
					name: '',
					group: {
						id: '',
					},
					defaultTranslation: '',
				};
			} else {
				this.hasErrors = true;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalAddEditLabel.vue